module.exports = __webpack_public_path__ + "static/media/image-4.e53e67e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Algorithms/image-4.png
// module id = 249
// module chunks = 0